// react
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from 'router';

// components
import LoadingPage from '@karehero/llama/components/pages/Loading/Loading';

// store
import { dispatch, useSelector } from 'store';
import {
  getToken,
  setToken,
  setOrganisationCreationCode,
} from 'store/slices/registrationSlice';

// hooks
import { useAuth } from 'hooks';

/**
 * MagicLinkRedirect attempts to store the provided token from query params and
 * redirects the user to register with Kinde.
 */
export const MagicLinkRedirect = () => {
  // hooks
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const storedToken = useSelector(getToken);
  const { register, isAuthenticated, ConnectionID } = useAuth();

  // effects
  useEffect(() => {
    const searchParamsToken = searchParams.get('token');
    const searchParamsEmail = searchParams.get('email');
    const partnerCode = searchParams.get('partnerCode');

    if (partnerCode) dispatch(setOrganisationCreationCode(partnerCode));
    if (searchParamsToken) dispatch(setToken(searchParamsToken));
    const currentToken = searchParamsToken || storedToken;

    if ((currentToken || partnerCode) && !isAuthenticated) {
      if (searchParamsEmail) {
        register(ConnectionID.EMAIL, searchParamsEmail);
      } else {
        register();
      }
      setTimeout(() => navigate(ROUTES.SIGN_IN), 2500);
    } else {
      navigate(ROUTES.SIGN_IN);
    }
  }, [
    storedToken,
    register,
    isAuthenticated,
    searchParams,
    navigate,
    dispatch,
  ]);

  return <LoadingPage />;
};

MagicLinkRedirect.displayName = 'MagicLinkRedirect';
export default MagicLinkRedirect;
